export const SIGLA_GRUPO_SOBRE_DOCUMENTO_MEDICO = 'GRDOCMED';
// BI
export const SIGLA_CAMPO_UTILIZAR_ATESTADO_ELETRONICO = 'USARATESTE';
export const SIGLA_CAMPO_POSSUI_DOCUMENTO_MEDICO = 'PATESTMED';
export const SIGLA_CAMPO_DATA_EMISSAO_ATESTADO = 'DTEATEST';
export const SIGLA_CAMPO_INFORMA_DATA_INICIO_REPOUSO = 'INFREPOUSO';
export const SIGLA_CAMPO_DATA_INICIO_DOENCA = 'DTIREPOUSO';
export const SIGLA_CAMPO_PRAZO_AFASTAMENTO = 'PRZREPOUSO';
export const SIGLA_CAMPO_DATA_FIM_REPOUSO = 'DTFREPOUSO';
export const SIGLA_CAMPO_CID_ATESTADO = 'CID';
export const SIGLA_CAMPO_CRM_ATESTADO = 'CRM';
export const SIGLA_CAMPO_UF_CRM_ATESTADO = 'UFCRM';
export const SIGLA_CAMPO_NOME_MEDICO_ATESTADO = 'NMMEDICO';
export const SIGLA_CAMPO_PROTOCOLO_ATESTADO = 'PRATESELET';
export const SIGLA_CAMPO_DUT_INFORMADO_REQUERENTE = 'DUTINFREQ';

export const SIGLA_CAMPO_TIPO_INCAPACIDADE = 'TPINCAP';
export const SIGLA_CAMPO_HOUVE_ACIDENTE_DE_TRABALHO = 'ACIDENTETB';

export const SIGLA_CAMPO_APS_MANUTENCAO = 'APSMANUT';
export const SIGLA_CAMPO_FLUXO_BI = 'FLUXOBI';
export const SIGLA_CAMPO_BI_MIGRADO_SABI = 'BIMIGRSABI';
export const SIGLA_CAMPO_SOLICITACAO_CONVERSAO_ATESTMED = 'SOLCONVPAT';

export const SIGLA_ANEXO_DEFINICAO_ATESTADO_MEDICO = 'DOCMED';
export const SIGLA_ANEXO_DEFINICAO_IDENTIFICACAO_OFICIAL = 'DOCID';
export const SIGLA_ANEXO_DEFINICAO_COMUNICACAO_ACIDENTE_TRABALHO = 'CAT';
